<template>
	<v-container fill-height fluid class="pa-0">
		<Motivo />
		<Excluir />
		<Novo />
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-toolbar flat dense>
						<v-spacer></v-spacer>
							<v-btn color="primary" small @click="criarNovoMotivo()">Novo</v-btn>
						</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170" 
						locale="pt-BR" dense fixed-header class="table-item" :items="motivos" :headers="fields" :items-per-page="15">
							<template v-slot:item.action="{ item }">
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
								<v-btn icon color="primary"  @click="excluir(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
						<v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, 
	showError, 
	//showSuccess 
	} from "@/config/global"
	import axios from 'axios'
	import Motivo from '@/components/cadastros/motivoAtendimentos/Motivo'
	import Excluir from '@/components/cadastros/motivoAtendimentos/ExcluirMotivo'
	import Novo from '@/components/cadastros/motivoAtendimentos/NovoMotivo'
	import metodos from '@/mixins/metodos.js'
	import Br from '@/config/barramento.js'

	export default{
		mixins:[metodos],
		components:{Motivo, Excluir, Novo},
		data(){
			return {
				loading: false,
				pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 8,
				motivos: [],
				fields: [
					{value: 'id', text: 'Código', align: 'center'},
					{value: 'descricao', text: 'Descricao', align: 'center'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
				],

			}
		},
		methods:{
			buscaMotivos(){
				this.loading = true
				const url = `${baseApiUrl}/Cadastros/motivosAtendimento/read.php`

				axios.get(url)
						.then(res => {
							if(res.data.codigo == "01"){
								this.motivos = res.data.dados
							}
							this.totalPaginas = Math.ceil(this.motivos.length / this.itensPorPagina)
							this.loading = false
						})
						.catch({showError})
			},

			editar(motivo){
				Br.setEditarMotivo(motivo)
			},

			criarNovoMotivo(){
				Br.setNovoMotivo()
			},

			excluir(motivo){

				Br.setExcluirMotivo(motivo)
				
			}

		},

		created(){
			this.buscaMotivos()

			Br.onMotivoExcluido(motivo => {
					let idx = this.motivos.findIndex((v) => {
                               return v.id == motivo.id
                            })

                            this.motivos.splice(idx, 1)
				})

			Br.onMotivoCadastrado(motivo => {
				
				this.motivos.push(motivo)
			})

			Br.onMotivoAtualizado(motivo => {
				let idx = this.motivos.findIndex((v) => {
					return v.id == motivo.id
				})

				this.motivos[idx] = motivo
			})

		}
	}
</script>

<style scoped>

</style>